import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { psychologistAppointmentsApi } from "../api/api"

export const useAllUsersWithAppointments = (trigger) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(psychologistAppointmentsApi.getAll)
        if (response.success) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData()
    }, [trigger])

    return data
}